import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

import { useConfiguration } from '../../../hooks/Configuration';

export interface IMessageResendProps {
    resend: () => void
}

function MessagResend({ resend }: IMessageResendProps) {
    const configuration = useConfiguration();

    return (
        <span
            style={{
                color: configuration?.styles.messageErrorColor
            }}>
            {configuration?.texts.messageRepeat}
            {' '}
            <FontAwesomeIcon
                icon={icon({ name: 'repeat' })}
                size='sm'
                className='cursor-pointer'
                title={'opakovat dotaz'}
                onClick={resend} />
        </span>
    );
}

export default MessagResend;
